import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectSemesterYearByClass {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectSemesterYearByClass = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectSemesterYearByClass) => {
  const itemList = useStoreState((state) => state.common.sessionYearListByClassId);

  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.id === id);
      onChange(value.id);
    }
  };

  // React.useEffect(() => {
  //   if (selected) {
  //     thanaListFetch(selected?.districtId);
  //   }
  // }, [selected])


  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Semister Year"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.id} value={type.id}>
            {type.name}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Semister Year</Option>
      )}
    </Select>
  );
};
